<template>
  <div class="view-wrapper">
    <ViewHeader title="Profile" :isFullViewport="true" :isClose="true">
      <template #actions>
        <Button class="p-button-outlined p-mr-3" @click="navigationTo">close</Button>
      </template>
    </ViewHeader>
    <ViewMain :isFullViewport="true">
      <div class="user-detail-container p-mt-4">
        <div class="profile-photo-container p-mb-4" style="padding-left: 20%">
          <div class="profile-photo">
            <img
              v-if="image.id && image.id.intID !== 0"
              alt="User profile photo"
              :src="image.fileLocation"
              width="100"
              height="100"
            />
          </div>
          <div>
            <div class="upload-image" @click="fileUpload">
              <i class="pi pi-plus" />
              <label>Choose Image </label>
            </div>
            <input
              type="file"
              id="new-document"
              style="display: none"
              ref="uploadInput"
              @change="onFileUpload"
            />
          </div>
        </div>

        <div style="padding-left: 10%">
          <div class="p-field p-inputtext-lg">
            <label for="firstName">First Name</label>
            <InputText
              id="firstName"
              type="text"
              v-model="user.firstName"
              autocomplete="new-password"
            />
          </div>
          <div class="p-field p-inputtext-lg">
            <label for="lastName">Last name</label>
            <InputText
              id="lastName"
              type="text"
              v-model="user.lastName"
              autocomplete="new-password"
            />
          </div>
          <div class="p-field p-inputtext-lg">
            <label for="email">Email address</label>
            <InputText
              id="email"
              type="email"
              v-model="user.emailAddress"
              autocapitalize="none"
              autocorrect="off"
              spellcheck="false"
              autocomplete="new-password"
            />
          </div>
        </div>

        <div style="padding-left: 5%;">
          <template v-if="isUserStatusPending">
            <h2 style="color: blue; margin-top: 1rem;">PENDING</h2>
          </template>
          <template v-if="!isUserStatusPending || isUserSuperUser">
            <div style="margin-top: 3.5rem;">
              <label for="newPassword">Change Password</label>
              <div class="p-field p-inputtext-lg p-mt-4"></div>

              <form class="p-field p-inputtext-lg p-mt-4">
                <label for="newPassword">New Password</label>
                <Password
                  id="newPassword"
                  :feedback="true"
                  v-model="newPassword"
                  autocapitalize="none"
                  autocorrect="off"
                  spellcheck="false"
                  autocomplete="new-password"
                />
              </form>

              <form class="p-field p-inputtext-lg">
                <label for="confirmPassword">Confirm New Password</label>
                <Password
                  id="confirmPassword"
                  :feedback="true"
                  v-model="confirmPassword"
                  autocapitalize="none"
                  autocorrect="off"
                  spellcheck="false"
                  autocomplete="new-password"
                />
              </form>

              <div class="p-d-flex p-jc-end" style="margin-top: 40px">
                <Button @click="updateUser">Save</Button>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="account-user-detail p-mt-4" v-if="!isUserAccountOwner && !isNonMemberSelf">
        <DataTable
          :autoLayout="true"
          :sortOrder="1"
          :value="[{}]"
          sortField="user.firstName"
          class="p-mb-6"
        >
          <Column header="Account">
            <template #body="">
              {{ $store.getters.currentAccount.contactCompanyName }}
            </template>
          </Column>
        </DataTable>
        <DataTable
          :autoLayout="true"
          :sortOrder="1"
          :value="[user]"
        >
          <Column header="Seat Type">
            <template #body="slotProps">
              {{ getSeatTypeForUser(slotProps.data) }}
            </template>
          </Column>
          <Column bodyStyle="text-align: center;">
            <template #body="slotProps">
              <div v-if="isCurrentUserAccountOwner && !isViewingSelf" class="p-d-flex p-ai-center p-jc-end">
                <Button
                  class="p-button-text p-button-danger"
                  label="Remove Team Member From Account"
                  @click="removeUserFromAccount($event, slotProps.data.id)"
                />
                <span 
                  v-tooltip.bottom="`Completely removes the team member from the account and all Plans / calendars they have access to at once. It frees up their seat.`" 
                  class="pi pi-question-circle tooltip-color">
                </span>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>

      <div class="account-user-detail-role" v-if="isUserAccountOwner">
        <DataTable
          :autoLayout="true"
          :sortOrder="1"
          :value="currentUserInArray"
          sortField="user.firstName"
        >
          <Column header="Account" bodyStyle="width:40%">
            <template #body="">
              {{ $store.getters.currentAccount.contactCompanyName }}
            </template>
          </Column>
          <Column header="Account Role">
            <template #body="">
              Account Owner
            </template>
          </Column>
          <Column bodyStyle="text-align:right">
            <template #body="">
              <p>
                To transfer account ownership contact
                <a class="contact-email text-link" href="mailto:hello@annumplanning.com"
                  >hello@annumplanning.com</a
                >
              </p>
            </template>
          </Column>
        </DataTable>
      </div>

      <ul class="team-plan" v-if="!isNonMemberSelf">
        <li class="team-plan__head is-user-profile-view">
          <span id="planName">Plan</span>
          <span id="role">
            Role
            <span
              v-tooltip.top="roleTooltip"
              class="pi pi-question-circle p-ml-2 tooltip-color"
            ></span>
          </span>
          <span v-show="isCurrentUserAccountOwner" id="budget">
            Budget
            <span
              v-tooltip.top="budgetTooltip"
              class="pi pi-question-circle p-ml-2 tooltip-color"
            ></span>
          </span>
          <span id="editRights">
            Channel Edit Rights
            <span
              v-tooltip.top="channelEditRightsTooltip"
              class="pi pi-question-circle p-ml-2 tooltip-color"
            ></span>
          </span>
          <span id="hiddenTags">
            Profile Tags
            <span
              v-tooltip.top="profileTagsTooltip"
              class="pi pi-question-circle p-ml-2 tooltip-color"
            ></span>
          </span>
        </li>
        <li v-if="userRolesFromCurrentPlans.length === 0">Loading...</li>
        <li
          class="team-table__item"
          v-for="(userRole, index) of userRolesFromCurrentPlans"
          :key="userRole.id.intID"
        >
          <PlanSettingsUserDetail
            :key="index"
            :userRole="userRole"
            :viewType="'user-profile'"
          />
        </li>
      </ul>
    </ViewMain>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

import ViewHeader from '@/components/ViewHeader.vue'
import ViewMain from '@/components/ViewMain.vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import User, {UserMostRecentView, UserStatus} from '@/models/User'
import FileUpload from 'primevue/fileupload'
import {AlertMessageSeverity} from '@/models/AlertMessage'
import Role from '@/models/Role'
import ID from '@/models/ID'
import UserRole from '@/models/UserRole'
import Plan from '@/models/Plan'
import Channel from '@/models/Channel'
import _ from 'lodash'
import MediaAsset from '@/models/MediaAsset'
import Tooltip from 'primevue/tooltip'
import PlanSettingsUserDetail from '@/components/PlanSettingsUserDetail.vue'

Vue.component('Button', Button)
Vue.component('InputText', InputText)
Vue.component('FileUpload', FileUpload)

export default Vue.extend({
  name: 'UserDetail',
  components: {
    ViewHeader,
    ViewMain,
    PlanSettingsUserDetail,
  },
  directives: {
    tooltip: Tooltip,
  },
  data: () => {
    return {
      newPassword: '',
      fileTypes: '.jpg,.jpeg,.png,.gif,.webp' as string,
      confirmPassword: '',
      editPlan: false as boolean,
      budgetOptions: [
        {
          name: 'Hide',
          code: false,
        },
        {
          name: 'View',
          code: true,
        },
      ],
      image: {} as MediaAsset,
      isImageUpload: false as boolean,
      isLoading: true as boolean,
      planAdminPermissionLevel: Role.LEVEL_PLAN_ADMIN as number,
      isConfirmOpen: false as boolean,
      channelEditRightsTooltip: `Assign channel edit rights when you want to ensure Contributors only plan within their designated Channels. When you give a Contributor edit rights to a specific Channel, they can add and edit Tactics in that Channel but can only view Tactics in the other Channels.

        Account Owners and Admins have edit rights for all Channels. Viewers have no Channel edit rights.
        `,
      roleTooltip: `Set each team member's role within the Plan. Every role contains the rights of the roles below it.

        Account Owner
        - Manages subscriptions, seats, and billing
        - One per account, contact Annum to transition to another team member

        Admin
        - Sets up marketing Channels and Tactic Types
        - Enters Tags
        - Manages Team Members
        - Activates Budget feature, sets annual Budget
        - Activates custom Calendars of Interest

        Contributor
        - Adds and edits Initiatives (Campaigns, Promotions, Key Dates, Monthly Themes)
        - Adds and edits Tactics

        Viewer
        - Views and filters data
        `,
      budgetTooltip: `Select whether you would like give Contributors and Viewers the ability to view Budget data in the Plan. Account Owners and Admins can always view Budget data.`,
      profileTagsTooltip: `Customize which tagged Initiatives and Tactics are visible for each team member. Activate the Tags related to the items that you'd like visible. Other options within each Tag category will, as a result, be hidden. Untagged items within the Plans will remain visible.`,
    }
  },
  mounted() {
    this.image = this.user.profileImage
    this.user.updateOldEmailAddress()

    document.addEventListener('click', this.clearConfirmOpenFlag)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clearConfirmOpenFlag)
  },
  computed: {
    userRolesFromCurrentPlans(): UserRole[] {
      let returnArray = [] as UserRole[]
      this.$store.getters.allPlans.forEach((plan) => {
        const userRolesInPlans = plan.userRoles.filter(
          (userRole) => {
            if(userRole.userId.intID !== this.user.id.intID){
              return false
            }

            // Only include highest role level for each plan
            const higherRolesForThisUser = plan.userRoles.filter((userRoleCheck) => userRoleCheck.userId.intID === userRole.userId.intID && userRoleCheck.roleId.intID < userRole.roleId.intID)
            if(higherRolesForThisUser.length){
              return false
            }

            // Hide integration users from non-super-admins
            if(!this.$store.getters.isCurrentUserSuperAdmin){
              const roleForUserRole = this.$store.getters.allRoles.find((role) => role.id.intID === userRole.roleId.intID)
              if(roleForUserRole?.isIntegration){
                return false
              }
            }

            return true
          }
        )

        userRolesInPlans.forEach((userRole) => {
          userRole.resetFromEditing()
        })

        returnArray = returnArray.concat(userRolesInPlans)
      })
      return returnArray
    },
    currentUserInArray(): User[] {
      return [this.$store.getters.currentUser]
    },
    currentPlan(): Plan {
      return this.$store.getters.currentPlan
    },
    user(): User {
      if (this.$route.params.userId) {
        if (
          this.$store.getters.currentUser &&
          this.$route.params.userId == this.$store.getters.currentUser.id.intID
        ) {
          return this.$store.getters.currentUser
        } else {
          return this.$store.getters.allAccountUsers.find(
            (user) => user.id.intID == Number(this.$route.params.userId)
          )
        }
      }
      return new User()
    },
    selectedCurrentAccountUserHighestRole(): Role {
      return this.$store.getters.allRoles.find((role) => role.id.intID === this.user.highestRoleId.intID)
    },
    accountOwnerUserRole(): UserRole {
      return this.$store.getters.currentAccount.userRoles.find(
          (accountUserRole) => accountUserRole.roleId.intID === 1
        )
    },
    isCurrentUserAccountOwner(): boolean {
      if(this.isUserSuperUser){
        return true
      }
      return this.accountOwnerUserRole && this.accountOwnerUserRole.userId.intID === this.$store.getters.currentUser.id.intID
    },
    isUserAccountOwner(): boolean {
      return this.accountOwnerUserRole && this.accountOwnerUserRole.userId.intID === this.user.id.intID
    },
    isUserSuperUser(): boolean {
      return this.$store.getters.isCurrentUserSuperAdmin
    },
    isViewingSelf(): boolean {
      const userId = this.user?.id?.intID
      const currentUserId = this.$store.getters.currentUser?.id?.intID
      return !!userId && !!currentUserId && userId === currentUserId
    },
    isNonMemberSelf(): boolean {
      return this.isViewingSelf && !this.isUserAccountMember
    },
    isUserAccountMember(): boolean {
      const userId = this.user?.id?.intID
      return (
        !!userId &&
        this.$store.getters.allAccountUsers.some((u) => u.id.intID === userId)
      )
    },
    isUserStatusPending(): boolean {
      return this.user.status === UserStatus.pending
    },
  },
  methods: {
    clearConfirmOpenFlag() {
      this.isConfirmOpen = false
    },
    getChannelForId(planId: ID, channelId: ID | string): Channel | undefined {
      this.isLoading = false
      const channelApiId =
        typeof channelId === 'string' ? channelId : channelId.apiID
      return this.getChannelsForPlanId(planId).find(
        (channel) => channel.id.apiID === channelApiId
      )
    },
    getChannelsForPlanId(planID: ID): Channel[] {
      const thisPlan = this.$store.getters.allPlans.find(
        (plan) => plan.id.intID === planID.intID
      )
      const isThisPlanLead = this.getIsLeadPlan(thisPlan)
      return thisPlan?.channels.filter(
        (channel) =>
          channel.id.intID !== this.currentPlan.id.intID &&
          ((isThisPlanLead && !channel.isNested) ||
            (!isThisPlanLead && (channel.isLead || channel.isNested)) ||
            (!channel.isLead && !channel.isNested))
      )
    },
    getIsLeadPlan(plan: Plan) {
      return plan.plans.length ? true : false
    },
    fileUpload() {
      const rowRef = this.$refs.uploadInput as HTMLDivElement
      rowRef.click()
    },
    removeUserFromAccount(event, userId) {
      if(this.isConfirmOpen){
        this.isConfirmOpen = false
        return
      }
      this.isConfirmOpen = true

      event.stopPropagation()
      this.$confirm.require({
        acceptLabel: 'Remove From Account',
        rejectLabel: 'Cancel',
        message: `Removing this individual from the account will revoke their login credentials and access to all Plans. They can only be added back to the Account and given access to Plans by an Admin. Click to confirm.`,
        target: event.currentTarget,
        acceptClass: 'btn-delete-accept',
        accept: async () => {
          // TODO: test code for cleaning up user roles (unsure when this was written as of 03.05.2025 - JV)
          // const userRolesForUserInAccount =
          //   this.$store.getters.currentAccount.userRoles.filter(
          //     (userRole) => userRole.userId.intID == this.user.id.intID
          //   )
          // await Promise.all(
          //   userRolesForUserInAccount.map(async (userRole) => {
          //     await this.$store.state.services.users.deleteUserRole(
          //       userRole.id.intID
          //     )
          //   })
          // )
          
          this.$store.state.services.users.deleteUserFromAccount(this.user.id.intID, this.$store.getters.currentAccount.id.intID).then(
            (response) => {
              // Update account and plan to refresh account seats
              this.$store.dispatch('refreshCurrentAccount').then(
                ()=>{
                  this.$store.dispatch('refreshCurrentPlan') 
                }
              )

              Vue.prototype.$toast.add({
                severity: AlertMessageSeverity.success,
                summary: 'User removed from account.',
                life: 3000,
              })

              this.$router.back()
            },
            (error) => {
              Vue.prototype.$toast.add({
                severity: AlertMessageSeverity.error,
                summary: 'Error',
                detail: 'User could not be removed from account.',
              })
            }
          )
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      })
    },
    deleteUserRole(event, userRole) {
      if(this.isConfirmOpen){
        this.isConfirmOpen = false
        return
      }
      this.isConfirmOpen = true

      event.stopPropagation()
      this.$confirm.require({
        acceptLabel: 'Revoke Plan Access',
        rejectLabel: 'Cancel',
        message: `Are you sure you want to revoke the team member's access to this Plan?`,
        target: event.currentTarget,
        acceptClass: 'btn-delete-accept',
        accept: () => {
          this.$store.state.services.users
            .deleteUserRole(userRole.id.intID)
            .then(
              () => {
                this.$store.dispatch('refreshCurrentAccount')

                Vue.prototype.$toast.add({
                  severity: AlertMessageSeverity.success,
                  summary: 'User removed from plan.',
                  life: 3000,
                })
              },
              (error) => {
                Vue.prototype.$toast.add({
                  severity: AlertMessageSeverity.error,
                  summary: 'Error removing user from plan. ' + error,
                  life: 3000,
                })
              }
            )
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      })
    },
    navigationTo() {
      this.$router.back()
    },
    cancelUpdate() {
      // TODO: router back?
    },
    updateUser() {
      if (!this.isImageUpload && this.confirmPassword !== this.newPassword) {
        Vue.prototype.$toast.add({
          severity: AlertMessageSeverity.error,
          summary: 'confirm password must match',
          life: 3000,
        })
        return
      }else{
        // Update user password before sending request
        this.user.password = this.newPassword
      }

      if (!this.user.mostRecentView) {
        // Ensure most recent view is not null
        this.user.mostRecentView = UserMostRecentView.dashboard
      }

      this.$store.getters.services.users
        .update(this.user)
        .then((user) => {
          if(user.profileImage){
            this.user.profileImage = MediaAsset.fromResponseObject(user.profileImage)
          }
          this.isImageUpload = false
          this.user.updateOldEmailAddress()
          Vue.prototype.$toast.add({
            severity: AlertMessageSeverity.success,
            summary: 'User updated',
            life: 3000,
          })
        },
        (error)=>{
          console.warn(error)
          if(error.message.includes('status code 422') || error.message.includes('status code 409')){
            Vue.prototype.$toast.add({
              severity: AlertMessageSeverity.error,
              summary: 'This email address is connected to a user who already has a Seat in this Account.',
            })
          }else{
            Vue.prototype.$toast.add({
              severity: AlertMessageSeverity.error,
              summary: 'Error updating user.',
              life: 3000,
            })
          }
        })
    },
    onFileUpload(event) {
      const fileData = event.target.files
      this.isImageUpload = true
      const file = new FormData()
      file.append('file', fileData[0])
      this.$store.getters.services.users.mediaAsset(file).then(
        (mediaAsset) => {
          this.image = mediaAsset
          this.user.profileImage = MediaAsset.fromResponseObject(mediaAsset)
          this.updateUser()
        },
        (error) => {
          Vue.prototype.$toast.add({
            severity: AlertMessageSeverity.error,
            summary: 'Error uploading file. Please try again.',
            life: 3000,
          })
        }
      )
    },
    getAccountUserName() {
      return (
        this.$store.getters.currentUser?.firstName +
        this.$store.getters.currentUser?.lastName
      )
    },
    getRoleTitleForRoleId(roleId: ID) {
      const role = this.$store.getters.allRoles.find(
        (role) => role.id.intID == roleId.intID
      )
      return role ? role.title : '-'
    },
    getSeatTypeForUser(user: User): string {
      // Integration is a separate seat pool - takes precedence over the highest-role
      // lookup, which never resolves to Integration (see Account.highestRoleId).
      // Match on roleId rather than userRole.role.isIntegration: the role object on
      // currentAccount.userRoles is only populated by populateFrontEndAccountObjects,
      // so its title (and isIntegration) can't be relied on here, but roleId always is.
      const integrationRole = this.$store.getters.allRoles.find(
        (role: Role) => role.isIntegration
      )
      const hasIntegrationRole = integrationRole && this.$store.getters.currentAccount.userRoles.some(
        (userRole: UserRole) =>
          userRole.userId.intID === user.id.intID &&
          userRole.roleId.intID === integrationRole.id.intID
      )
      if (hasIntegrationRole) {
        return 'Integration'
      }
      return this.getRoleTitleForRoleId(user.highestRoleId)
    },
    userCanViewBudget(users) {
      const user = users.filter(
        (user) => user.userId.intID == this.$store.getters.currentUser.id.intID
      )
      return user[0].canViewBudget ? true : false
    },
    beginEditingUserRole(userRole: UserRole) {
      userRole.isEditing = true
    },
    planForUserRole(userRole: UserRole): Plan | undefined {
      return this.$store.getters.currentAccount.plans.find((plan)=>plan.id.intID === userRole.planId.intID)
    },
    channelCountForPlan(plan: Plan): number {
      const isThisPlanLead = plan.plans.length ? true : false
      return plan.channels.filter(
        (channel) => channel.name !== Channel.CHANNEL_NAME_INITIATIVES && ((isThisPlanLead && !channel.isNested) || (!isThisPlanLead && (channel.isLead || channel.isNested)) || (!channel.isLead && !channel.isNested))
      ).length
    },
    editUserRole(userRole: UserRole) {
      const planForUserRole = this.planForUserRole(userRole)
      const rolePayload = new UserRole()

      rolePayload.id = userRole.id
      rolePayload.userId = userRole.userId
      rolePayload.planId = userRole.planId
      rolePayload.roleId = userRole.editingValues.roleId
      rolePayload.accountId = this.$store.getters.currentAccount.id
      rolePayload.canViewBudget = userRole.canViewBudget
      if (userRole.editingValues.channels.length > 0) {
        rolePayload.channels = [...userRole.editingValues.channels]
      }
      if(rolePayload.roleId.intID === 4 || ( rolePayload.roleId.intID === 5 && planForUserRole && userRole.channels.length >= this.channelCountForPlan(planForUserRole))){
        rolePayload.canEditAllChannels = true
      }else{
        rolePayload.canEditAllChannels = false
      }

      this.$store.getters.services.users
        .updateUserRole(rolePayload)
        .then(() => {
          userRole.roleId = userRole.editingValues.roleId
          userRole.channels = [...userRole.editingValues.channels]
          userRole.isEditing = false
        })
        .catch((error) => {
          console.warn(error)
          Vue.prototype.$toast.add({
            severity: AlertMessageSeverity.error,
            summary: 'Error editing user details.',
            detal: error,
          })
        })
    },
    onRoleChange(event, userRole) {
      // Default to allow budget view
      userRole.editingValues.canViewBudget = true

      switch (userRole.editingValues.roleId.intID) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          // Account-level (1-3), Admin (4), or Contributor (5) role selected
          userRole.editingValues.channels = this.getChannelsForPlanId(
            userRole.planId
          ).map((channel) => channel.id)
          break
        case 6:
          // Viewer role selected
          userRole.editingValues.channels = []
          break
        default:
          // Do nothing
          break
      }
    },
  },
})
</script>

<style lang="scss">
@import '@/styles/_imports.scss';

.upload-image {
  @include font-mulish;
  background: black;
  padding: 10px 10px;
  color: white;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-top: 5px;
  width: 128px;
  label {
    margin-left: 6px;
    cursor: pointer;
  }
  i {
    border: 2px solid #888686;
    border-radius: 50%;
    padding: 2px;
    cursor: pointer;
  }
}
.user-detail-container {
  display: flex;
  input {
    width: 300px;
  }
  label {
    font-size: 12px;
  }
}
.profile-photo {
  border-radius: 50%;
  align-items: center;
  text-align: center;
  img {
    width: 10rem;
    height: 10rem;
    object-fit: cover;
  }
}

.account-user-detail {
  width: 45%;
}

.account-user-detail-role {
  width: 65%;
  margin-top: 50px;
}

.plan-setting {
  display: flex;
  justify-content: space-between;
  background: #efefef;
  padding: 0px 10px;
}

.plan-container {
  margin-top: 50px;
}

.plan-setting-detail {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebebeb;
  padding: 0px 10px;
}

.team-plan {
  margin-top: 50px;
  padding: 0px !important;
}

.contact-email {
  @include font-mulish-light;
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.team-plan {
  position: relative;

  &__edit-overlay {
    position: absolute;
    left: -10px;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba($color: lightgray, $alpha: 0.4);
    z-index: 9;
    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__head {
    background-color: rgb(239 239 239);
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    font-weight: 400;
  }
  &__item {
    padding: 15px 20px 15px 10px;
    flex-direction: row;
    font-size: 11px;
    border-bottom: 1px solid #b0abab;

    &:last-child {
      border-bottom: none;
    }
    .addUserBtn {
      padding: 10px !important;
    }
    .user-view {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
    #avatar {
      position: absolute;
      left: -50px;
      top: 5px;
      height: 40px;
      aspect-ratio: 1;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .search-field {
      position: relative;
      width: 20%;
      .p-inputtext {
        width: 100%;
      }
      .pi {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
      }
      .p-listbox {
        width: 100% !important;
        position: absolute;
        z-index: 2;
      }
    }
    // &:last-child {
    //   .p-dropdown {
    //     width: 20%;
    //   }
    // }
  }
  &__subitem {
    padding: 15px 20px 15px 10px;
    flex-direction: row;
    font-size: 11px;
    border-top: 1px solid #e9e8e8;
    border-bottom: 1px solid #b0abab;

    &:last-child {
      border-bottom: 1px solid #b0abab;
    }
    .addUserBtn {
      padding: 10px !important;
    }
    .user-view {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
    #avatar {
      position: absolute;
      left: -50px;
      top: 5px;
      height: 40px;
      aspect-ratio: 1;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .search-field {
      position: relative;
      width: 20%;
      .p-inputtext {
        width: 100%;
      }
      .pi {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
      }
      .p-listbox {
        width: 100% !important;
        position: absolute;
        z-index: 2;
      }
    }
    // &:last-child {
    //   .p-dropdown {
    //     width: 20%;
    //   }
    // }
  }
  #firstName {
    width: 20%;
  }
  #role,
  #budget,
  #editRights,
  #actionsContainer {
    width: 15%;
    padding-left: 5%;
  }
  #actionsContainer {
    display: flex;
    align-items: center;
    gap: 1rem;
    width: 30%;
    text-align: center;
  }
  #toggleDropdown {
    position: absolute;
    right: 0;
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    i {
      font-size: 1rem;
    }
  }
  .edit-user,
  .add-user {
    border-color: transparent;
    // padding: 10px 0 10px 10px;
    display: flex;
    flex-direction: row;
    label {
      margin-bottom: 8px;
      font-size: 15px;
      @include font-mulish-light;
    }
    .p-button-text {
      @include font-mulish-light;
      padding-left: 4px;
      padding-right: 5px;
      padding-bottom: 3px;
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      .pi-plus-circle {
        margin-right: 3px;
      }
    }
    &__field {
      padding-right: 15px;
      display: flex;
      flex-direction: column;
    }
    #addUser,
    #editUser {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      padding-bottom: 5px;
      gap: 5px;
      cursor: pointer;
      i {
        font-size: 12px;
      }
      span {
        width: max-content;
      }
    }
  }
}

.team-subPlan {
  position: relative;
  @include font-mulish-light;
  &__edit-overlay {
    position: absolute;
    left: -10px;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba($color: lightgray, $alpha: 0.4);
    z-index: 9;
    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__head {
    background-color: rgb(239 239 239);
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    font-weight: 400;
  }

  &__subitem {
    padding: 15px 20px 15px 10px;
    flex-direction: row;
    font-size: 14px;
    border-top: 1px solid #b0abab;
    margin-top: 5px;

    .addUserBtn {
      padding: 10px !important;
    }
    .user-view {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
    #avatar {
      position: absolute;
      left: -50px;
      top: 5px;
      height: 40px;
      aspect-ratio: 1;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .search-field {
      position: relative;
      width: 20%;
      .p-inputtext {
        width: 100%;
      }
      .pi {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
      }
      .p-listbox {
        width: 100% !important;
        position: absolute;
        z-index: 2;
      }
    }
    // &:last-child {
    //   .p-dropdown {
    //     width: 20%;
    //   }
    // }
  }
  #firstName {
    width: 30%;
  }
  #lastName {
    width: 20%;
  }

  #role {
    width: 20%;
    .edit {
      padding-left: 1px;
    }
  }
  #budget {
    width: 20%;
    .edit {
      padding-left: 1px;
    }
  }
  #editRights {
    width: 20%;
    .edit {
      padding-left: 6px;
    }
  }
  #toggleDropdown {
    position: absolute;
    right: 0;
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    i {
      font-size: 1rem;
    }
  }
  .edit-user,
  .add-user {
    border-color: transparent;
    // padding: 10px 0 10px 10px;
    display: flex;
    flex-direction: row;
    label {
      margin-bottom: 8px;
      font-size: 15px;
      @include font-mulish-light;
    }
    .p-button-text {
      @include font-mulish-light;
      padding-left: 5px;
      padding-right: 5px;
      padding-bottom: 3px;
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      .pi-plus-circle {
        margin-right: 3px;
      }
    }
    &__field {
      padding-right: 15px;
      display: flex;
      flex-direction: column;
    }
    #addUser,
    #editUser {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      padding-bottom: 5px;
      gap: 5px;
      cursor: pointer;
      i {
        font-size: 12px;
      }
      span {
        width: max-content;
      }
    }
  }
}
.mutliselect {
  width: 200px;
}
</style>
